import { Button, Chip, Tooltip } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import { useTranslation } from "react-i18next";
import { IAcademicYear } from "types/common.types";
import { useState } from "react";
import { CommonModal } from "components";
import { reRenderTable } from "components/elements/table/reducer/table.slice";
import { useAppDispatch } from "store/storeHooks";
import { toast } from "react-toastify";

export const useAcademicYearColumns = () => {
  const { t } = useTranslation();
  const [startModalId, setStartModalId] = useState<string | null>(null);
  const [endModalId, setEndModalId] = useState<string | null>(null);
  const dis = useAppDispatch();

  const { mutate: academicYearStart, status: startStatus } = useApiMutation(
    `academic-year/start/${startModalId}`,
    "POST",
    {
      onSuccess: () => {
        setStartModalId(null);
        dis(reRenderTable(true));
      }
    }
  );

  const { mutate: academicYearEnd, status: endStatus } = useApiMutation(
    `academic-year/end/${endModalId}`,
    "POST",
    {
      onSuccess: () => {
        setEndModalId(null);
        dis(reRenderTable(true));
      }
    }
  );

  const columns: GridColumns<IAcademicYear> = [
    {
      field: t("TABLE.ACADEMIC_YEAR_RANGE")!,
      renderCell(params) {
        return `${dayjs(params?.row?.startsAt).format("DD.MM.YYYY")} - ${dayjs(params?.row?.endsAt).format("DD.MM.YYYY")}`;
      },
    },
    {
      field: t("TABLE.STATUS")!,
      renderCell(params) {
        return params.row.isCurrent ?
          <Chip color="primary" label={t("general.active")} />
          :
          <Chip color="warning" label={t("general.archive")} />
      },
      maxWidth: 100
    },
    {
      field: t("TABLE.ACTION")!,
      renderCell(params) {
        return <div className="flex gap-2">
          {!params?.row?.startedAt && !params?.row?.endedAt && (
            <Tooltip title={t("general.start_academic_year")} placement="top">
              <Button
                variant="contained"
                size="small"
                onClick={() => setStartModalId(params?.row?._id)}
              >
                {t("general.start")}
              </Button>
            </Tooltip>
          )}

          <Tooltip title={t("general.end_academic_year")} placement="top">
            <Button
              variant="outlined"
              size="small"
              disabled={!params?.row?.startedAt || !!params?.row?.endedAt}
              onClick={() => {
                if (params?.row?.isCurrent) {
                  toast.warning("Joriy yilni yakunlash mumkin emas!");
                } else {
                  setEndModalId(params?.row?._id);
                }
              }}
            >
              {t(!!params?.row?.endedAt ? "general.ended" : "general.end")}
            </Button>
          </Tooltip>

        </div>
      }
    }
  ];

  return {
    columns,
    modals: (
      <>
        <CommonModal
          title={t("general.confirm_start_academic_year")!}
          open={!!startModalId}
          setOpen={setStartModalId}
          onSave={() => academicYearStart({})}
          status={startStatus}
        />
        <CommonModal
          title={t("general.confirm_end_academic_year")!}
          open={!!endModalId}
          setOpen={setEndModalId}
          onSave={() => academicYearEnd({})}
          status={endStatus}
        />
      </>
    )
  };
};